// <div data-controller="web--articles">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "form" ];
  static classes = [ "" ]
  static values = {};

  initialize() {

  }

  onSelectRegion(e) {
    if (e.target.value) {
      window.location.href = `/${e.target.value}${window.location.search}`;
    } else if (e.target.dataset.defaultUid) {
      window.location.href = `/${e.target.dataset.defaultUid}${window.location.search}`;
    } else {
      window.location.href = `/buy-sell${window.location.search}`;
    }
  }

  connect() {

  }

  disconnect() {

  }
}